import type { SourceType } from '../types/extraction';

export function getSourceType(file: File): SourceType {
  const mimeType = file.type.toLowerCase();
  const extension = file.name.split('.').pop()?.toLowerCase();

  if (mimeType.includes('pdf') || extension === 'pdf') return 'pdf';
  if (mimeType.includes('csv') || extension === 'csv') return 'csv';
  if (mimeType.includes('spreadsheet') || ['xlsx', 'xls'].includes(extension || '')) {
    return extension === 'xlsx' ? 'xlsx' : 'xls';
  }
  if (mimeType.includes('image')) return 'image';

  return 'image'; // Default
}

export function isTextBasedFile(sourceType: SourceType): boolean {
  return ['csv', 'xlsx', 'xls'].includes(sourceType);
}
